import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6640b8d8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "breathing-box" };
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        type: { default: "success" }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(["breathing-light", [__props.type + '-bg-light']])
                }, null, 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["point", __props.type + '-bg'])
                }, null, 2)
            ]));
        };
    }
});
